import { useEffect, useRef } from 'react';
import { chatActivityItemKey } from './chatActivityItemKey.ts';

/**
 * The activity panel holds focus while open and, when it closes, hands it to
 * the line of the item last on screen — or back to wherever it came from when
 * that line is gone.
 */
export function useActivityPanelFocus(stepId: string, index: number) {
  const panel = useRef<HTMLElement>(null);
  const lineKey = useRef(chatActivityItemKey(stepId, index));

  useEffect(() => {
    lineKey.current = chatActivityItemKey(stepId, index);
  }, [stepId, index]);

  useEffect(() => {
    const before = document.activeElement;
    panel.current?.focus();
    const key = lineKey;

    return () => {
      const line = document.querySelector<HTMLElement>(
        `[data-activity-item="${CSS.escape(key.current)}"]`,
      );
      (line ?? (before instanceof HTMLElement ? before : null))?.focus();
    };
  }, []);

  return panel;
}
